/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { MedicalSystemSubCategory } from './MedicalSystemSubCategory';
import {
    MedicalSystemSubCategoryFromJSON,
    MedicalSystemSubCategoryFromJSONTyped,
    MedicalSystemSubCategoryToJSON,
} from './MedicalSystemSubCategory';
import type { RtSystemCategory } from './RtSystemCategory';
import {
    RtSystemCategoryFromJSON,
    RtSystemCategoryFromJSONTyped,
    RtSystemCategoryToJSON,
} from './RtSystemCategory';
import type { TaskTypeDescription } from './TaskTypeDescription';
import {
    TaskTypeDescriptionFromJSON,
    TaskTypeDescriptionFromJSONTyped,
    TaskTypeDescriptionToJSON,
} from './TaskTypeDescription';

/**
 * 
 * @export
 * @interface GetMedicalSystemsForTaskRequestDto
 */
export interface GetMedicalSystemsForTaskRequestDto {
    /**
     * 
     * @type {TaskTypeDescription}
     * @memberof GetMedicalSystemsForTaskRequestDto
     */
    taskType: TaskTypeDescription;
    /**
     * 
     * @type {RtSystemCategory}
     * @memberof GetMedicalSystemsForTaskRequestDto
     */
    category: RtSystemCategory;
    /**
     * 
     * @type {MedicalSystemSubCategory}
     * @memberof GetMedicalSystemsForTaskRequestDto
     */
    subCategory: MedicalSystemSubCategory;
    /**
     * 
     * @type {string}
     * @memberof GetMedicalSystemsForTaskRequestDto
     */
    $type?: GetMedicalSystemsForTaskRequestDtoTypeEnum;
}


/**
 * @export
 */
export const GetMedicalSystemsForTaskRequestDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedTaskItemComponentGetMedicalSystemsForTaskRequestDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.GetMedicalSystemsForTaskRequestDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type GetMedicalSystemsForTaskRequestDtoTypeEnum = typeof GetMedicalSystemsForTaskRequestDtoTypeEnum[keyof typeof GetMedicalSystemsForTaskRequestDtoTypeEnum];


/**
 * Check if a given object implements the GetMedicalSystemsForTaskRequestDto interface.
 */
export function instanceOfGetMedicalSystemsForTaskRequestDto(value?: unknown): value is GetMedicalSystemsForTaskRequestDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(GetMedicalSystemsForTaskRequestDtoTypeEnum)[0];
}

export function GetMedicalSystemsForTaskRequestDtoFromJSON(json: any): GetMedicalSystemsForTaskRequestDto {
    return GetMedicalSystemsForTaskRequestDtoFromJSONTyped(json, false);
}

export function GetMedicalSystemsForTaskRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetMedicalSystemsForTaskRequestDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'taskType': TaskTypeDescriptionFromJSON(json['taskType']),
        'category': RtSystemCategoryFromJSON(json['category']),
        'subCategory': MedicalSystemSubCategoryFromJSON(json['subCategory']),
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function GetMedicalSystemsForTaskRequestDtoToJSON(value?: GetMedicalSystemsForTaskRequestDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'taskType': TaskTypeDescriptionToJSON(value.taskType),
        'category': RtSystemCategoryToJSON(value.category),
        'subCategory': MedicalSystemSubCategoryToJSON(value.subCategory),
        '$type': value.$type,
    });
}

